import { useEffect, useRef } from 'react';
import { useOnClickOutside } from '@crehana/react-hooks';
import { clsx } from 'clsx';
import { generalContainerClassName, iconsClassName, stateContainerClassName } from "./constants";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FormElementContainer = function FormElementContainer(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    leadingIcon = _ref.leadingIcon,
    fieldState = _ref.fieldState,
    trailingIcon = _ref.trailingIcon,
    leadingElement = _ref.leadingElement,
    trailingElement = _ref.trailingElement,
    draggable = _ref.draggable,
    onDrag = _ref.onDrag,
    onDragStart = _ref.onDragStart,
    onDragEnd = _ref.onDragEnd,
    formElement = _ref.formElement,
    _ref$onClickOutside = _ref.onClickOutside,
    onClickOutside = _ref$onClickOutside === void 0 ? function () {} : _ref$onClickOutside;
  var containerRef = useRef(null);
  useOnClickOutside(containerRef, onClickOutside);

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    var divElement = containerRef.current;

    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (!divElement) return;
    var focusListener = function focusListener() {
      var _divElement$querySele;
      return (_divElement$querySele = divElement.querySelector('input')) === null || _divElement$querySele === void 0 ? void 0 : _divElement$querySele.focus();
    };
    divElement.addEventListener('click', focusListener);
    return function () {
      return divElement.removeEventListener('click', focusListener);
    };
  }, [containerRef]);
  return /*#__PURE__*/_jsxs("div", {
    ref: containerRef,
    className: clsx(generalContainerClassName, size === 'sm' ? 'tw-h-4 tw-font-body4' : 'tw-h-5.6 tw-font-body3', stateContainerClassName[fieldState]),
    draggable: draggable,
    onDragStart: onDragStart,
    onDragEnd: onDragEnd,
    onDrag: onDrag,
    children: [leadingIcon && !leadingElement && leadingIcon({
      size: 24,
      className: clsx(iconsClassName[fieldState], 'tw-ml-1.2 tw-shrink-0')
    }), leadingElement, formElement, trailingElement, trailingIcon && !trailingElement && trailingIcon({
      size: 24,
      className: clsx(iconsClassName[fieldState], 'tw-mr-1.6 tw-shrink-0')
    })]
  });
};
export default FormElementContainer;